import { SERVICE_TYPES } from '@features/components/CaseFormBlocks/config';
import { ServiceType } from '@/api/apis/case';
import { EmployeeRole } from '@/api/apis/resources';
import { CASE_BOARD_PERMISSIONS_BY_ROLES, CaseBoardPermissions } from '@/permissions';

export const getRegularCaseCreatorRoles = (): EmployeeRole[] =>
  CASE_BOARD_PERMISSIONS_BY_ROLES[CaseBoardPermissions.CaseDraftCreate].filter(
    (role): role is EmployeeRole => role !== EmployeeRole.ClinicalAuditor,
  );

export const isClinicalAuditorRestrictedToDirectAcquisition = ({
  employeeRoles,
}: {
  employeeRoles?: EmployeeRole[];
}): boolean => {
  const roles = employeeRoles ?? [];

  const hasClinicalAuditorRole = roles.includes(EmployeeRole.ClinicalAuditor);

  const hasRegularCaseCreatorRole = roles.some((role) => getRegularCaseCreatorRoles().includes(role));

  return hasClinicalAuditorRole && !hasRegularCaseCreatorRole;
};

export const getFilteredServiceTypes = (includeDirectAcquisition: boolean) => {
  if (includeDirectAcquisition) return SERVICE_TYPES;

  return SERVICE_TYPES.filter(({ value }) => value !== ServiceType.DirectAcquisition);
};
